import React, { useState, useRef } from 'react';
import JoditEditor from 'jodit-react';
import Button from "react-bootstrap/Button";
import { addPbsPlansStock } from "../../schemas";
import { useFormik } from "formik";
import { Formik, Form, ErrorMessage } from 'formik';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ADMIN_ID, POST_PBS_PLANS_URL } from "../../env";
// import {
//   sampleDataAboutPlan,
//   sampleDataMOBP,
//   sampleDataSecondaryPrevention,
//   sampleDataReactiveStartegies,
//   sampleDataPostIncidentSupport
// } from "./SamplePbsData";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import CustomSelect from "../../components/forms-fields/CustomSelectStaffMembers";
import Layout from '../../components/layouts/Layout';
import { Link } from 'react-router-dom';
import moment from 'moment/moment';
import Input from '../../components/forms-fields/Input';

function AddPbsPlans() {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddPbsPlans, setIsToastAddPbsPlans] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  // const [isStaffId, setIsStaffId] = useState(false);
  // const [errorMessage, setErrorMessage] = useState(false);
  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    setFieldValue("staffId", userId)
  };

  const aboutPlanRef = useRef(null);
  const AimOfPositiveBehaviourPlanRef = useRef(null);
  const settingEventsPlanRef = useRef(null);
  const discriminativeStimuliPlanRef = useRef(null);
  const behaviourOfConcernPlanRef = useRef(null);
  const managementOfBehaviorPlanRef = useRef(null);
  const postReducingLikeliHoodRef = useRef(null);
  const secondaryPreventionRef = useRef(null);
  const postThingsToDisplayAmberBehaviorRef = useRef(null);
  const reactiveStartegiesRef = useRef(null);
  const postThingsToTryRef = useRef(null);
  const postIncidentSupportRef = useRef(null);
  // const [aboutPlan, setAboutPlan] = useState('');
  // const [managementOfBehaviorPlan, setManagementOfBehaviorPlan] = useState('');
  // const [allAboutMePlan, setAllAboutMePlan] = useState('');
  // const [aimOfPositiveBehaviourPlan, setAimOfPositiveBehaviourPlan] = useState('');
  // const [settingEventsPlan, setSettingEventsPlan] = useState('');
  // const [discriminativeStimuliPlan, setDiscriminativeStimuliPlan] = useState('');
  // const [behaviourOfConcernPlan, setBehaviourOfConcernPlan] = useState('');
  // const [secondaryPrevention, setSecondaryPrevention] = useState('');
  // const [reactiveStartegies, setReactiveStartegies] = useState('');
  // const [postIncidentSupport, setPostIncidentSupport] = useState('');
  // const [postThingsToTry, setPostThingsToTry] = useState('');
  // const [thingsToDisplayAmberBehavior, setThingsToDisplayAmberBehavior] = useState('');
  // const [reducingLikeliHood, setReducingLikeliHood] = useState('');

  const [suFormData, setSuFormData] = useState({

    userId: userDetails?._id,
    staffId: ADMIN_ID,
    completionDate: "",
    aboutPlan: "",
    managementOfBehaviorPlan: "",
    secondaryPrevention: "",
    reactiveStartegies: "",
    postIncidentSupport: "",
    allAboutMePlan: "",
    aimOfPositiveBehaviourPlan: "",
    settingEventsPlan: "",
    discriminativeStimuliPlan: "",
    behaviourOfConcernPlan: "",
    postThingsToTry: "",
    thingsToDisplayAmberBehavior: "",
    reducingLikeliHood: "",

  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    setFieldTouched,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addPbsPlansStock,
    onSubmit: async (values) => {
      try {

        setIsSubmitButtonClicked(true);
        await postAddPbsPlansFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastAddPbsPlans(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);

    } else if (
      method === "postAddPbsPlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddPbsPlans(true);
      toastSuccessMessages(toast.success, data?.message, "/pbs-plans", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
      }, 2000);
    }
  };

  const postAddPbsPlansFormData = catchAsync(async (req, res) => {
    // const updatedValues = {
    //   ...values,
    //   aboutPlan: aboutPlan,
    //   managementOfBehaviorPlan: managementOfBehaviorPlan,
    //   secondaryPrevention: secondaryPrevention,
    //   reactiveStartegies: reactiveStartegies,
    //   postIncidentSupport: postIncidentSupport,
    //   allAboutMePlan: allAboutMePlan,
    //   aimOfPositiveBehaviourPlan: aimOfPositiveBehaviourPlan,
    //   settingEventsPlan: settingEventsPlan,
    //   discriminativeStimuliPlan: discriminativeStimuliPlan,
    //   behaviourOfConcernPlan: behaviourOfConcernPlan,
    //   postThingsToTry: postThingsToTry,
    //   thingsToDisplayAmberBehavior: thingsToDisplayAmberBehavior,
    //   reducingLikeliHood: reducingLikeliHood,

    // }
    const response = await postRecords(POST_PBS_PLANS_URL, values);
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddPbsPlansFormData", response);
  });


  const loadSamplePbsData = (fieldName, sampleData, fieldVariable) => {
    setFieldValue(fieldName, sampleData)
    fieldVariable(sampleData)
  }

  return (
    <>
      <Layout
        pageTitleText={
          <>
            PBS Plans
          </>
        }
      >
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent">
            <div className="mainContentText">
              <h3>Add New Record</h3>

              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row align-items-center">

                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <CustomSelect
                          id=""
                          name="staffId"
                          onSelect={handleUserSelect}
                          filterBy={""}
                          label={"Select Staff"}
                          customError={touched?.staffId && errors?.staffId}
                          errorMessage={errors?.staffId}
                          errorClass={
                            touched?.staffId && errors?.staffId
                              ? "validationError"
                              : ""
                          }
                        />
                      </div>
                    </div> */}


                    <div className="col-md-6">
                      <div className="form-group">
                        <Input
                          type="date"
                          datePicker={true}
                          name="completionDate"
                          selected={values?.completionDate ? moment(values?.completionDate).toDate() : null}
                          dateFormat="dd/MM/yyyy"
                          onChange={(completionDate) => setFieldValue("completionDate", moment(completionDate).valueOf())}
                          onBlur={() => setFieldTouched("completionDate", true)} // Ensure Formik's touched state is set on blur
                          labelText="Due Date"
                          placeholderText="Select Due Date"
                          customError={touched?.completionDate && errors?.completionDate}
                          errorMessage={errors?.completionDate}
                          errorClass={touched?.completionDate && errors?.completionDate ? "validationError" : ""}
                          requiredStar={true}
                          showYearDropdown={true}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="formActionButtons">
                        <Link to="/pbs-plans">
                          <span
                            className="btn btn-sm btn-outline-primary"
                          >
                            Cancel
                          </span>
                        </Link>
                        {isSubmitButtonClicked ? (
                          <Button
                            className="btn-sm"
                            variant="primary"
                            disabled
                          >
                            Loading...
                          </Button>
                        ) : (
                          <Button className="btn-sm" variant="primary" type="submit">
                            Save
                          </Button>
                        )}
                      </div>
                    </div>

                    {/* All about me (TITLE) */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>All about me </h3>
                          {/* <span onClick={() => { loadSamplePbsData("aboutPlan", sampleDataAboutPlan, setAboutPlan) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="aboutPlanEditor"
                          ref={aboutPlanRef}
                          value={values?.aboutPlan}
                          tabIndex={1}
                          // onChange={(newContent) => { setAboutPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("aboutPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />
                        {/* {errors.aboutPlanEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.aboutPlanEditor}</div>
                          </div>
                        )} */}


                      </div>
                    </div>

                    {/* Aim of Positive Behaviour Support Plan */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>Aim of Positive Behaviour Support Plan</h3>
                        </header>
                        <JoditEditor
                          name="AimOfPositiveBehaviourPlanEditor"
                          ref={AimOfPositiveBehaviourPlanRef}
                          value={values?.aimOfPositiveBehaviourPlan}
                          tabIndex={2}
                          // onChange={(newContent) => { setAimOfPositiveBehaviourPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("aimOfPositiveBehaviourPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />
                      </div>
                    </div>

                    {/* Setting Events (Slow Triggers)  */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>Setting Events (Slow Triggers)</h3>
                        </header>
                        <JoditEditor
                          name="settingEventsPlanEditor"
                          ref={settingEventsPlanRef}
                          value={values?.settingEventsPlan}
                          tabIndex={2}
                          // onChange={(newContent) => { setSettingEventsPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("settingEventsPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />
                      </div>
                    </div>

                    {/* Discriminative Stimuli (Fast Triggers)  */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>Discriminative Stimuli (Fast Triggers)</h3>
                        </header>
                        <JoditEditor
                          name="discriminativeStimuliPlanEditor"
                          ref={discriminativeStimuliPlanRef}
                          value={values?.discriminativeStimuliPlan}
                          tabIndex={2}
                          // onChange={(newContent) => { setDiscriminativeStimuliPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("discriminativeStimuliPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />
                      </div>
                    </div>

                    {/* Behaviour of Concern   */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>Behaviour of Concern</h3>
                        </header>
                        <JoditEditor
                          name="behaviourOfConcernPlanEditor"
                          ref={behaviourOfConcernPlanRef}
                          value={values?.behaviourOfConcernPlan}
                          tabIndex={2}
                          // onChange={(newContent) => { setBehaviourOfConcernPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("behaviourOfConcernPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />

                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="pbsFieldWrapper p-0 m-0 border-bottom-0">
                        <header className="alert alert-dark mobTitle border-bottom-0">
                          <h3>Management of Behavioural Presentation<br />
                            Primary Prevention – Proactive</h3>
                        </header>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark mobpBg">
                          <h3>When I am calm and at baseline</h3>
                          {/* <span onClick={() => { loadSamplePbsData("managementOfBehaviorPlan", sampleDataMOBP, setManagementOfBehaviorPlan) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="managementOfBehaviorPlanEditor"
                          ref={managementOfBehaviorPlanRef}
                          value={values?.managementOfBehaviorPlan}
                          tabIndex={2}
                          // onChange={(newContent) => { setManagementOfBehaviorPlan(newContent) }}
                          onChange={(newContent) => setFieldValue("managementOfBehaviorPlan", newContent)}
                          onBlur={handleBlur}
                          className='mobp'
                        />
                        {/* {errors.managementOfBehaviorPlanEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.managementOfBehaviorPlanEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>

                    {/* Reducing likelihood of target behaviour occurring  */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark cleanBg">
                          <h3>Reducing likelihood of target behaviour occurring</h3>
                          {/* <span onClick={() => { loadSamplePbsData("reducingLikeliHood", sampleDataReducingLikeliHood, setReducingLikeliHood) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="postReducingLikeliHoodEditor"
                          ref={postReducingLikeliHoodRef}
                          value={values?.reducingLikeliHood}
                          tabIndex={5}
                          // onChange={(newContent) => { setReducingLikeliHood(newContent) }}
                          onChange={(newContent) => setFieldValue("reducingLikeliHood", newContent)}
                          onBlur={handleBlur}
                          className='clean'
                        />
                        {/* {errors.postReducingLikeliHood && (
                          <div className="validationError">
                            <div className="text-danger">{errors.postReducingLikeliHood}</div>
                          </div>
                        )} */}
                      </div>
                    </div>


                    {/* Secondary Prevention */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark spBg">
                          <h3>Secondary Prevention<br />
                            Indicators I am moving away from baseline</h3>
                          {/* <span onClick={() => { loadSamplePbsData("secondaryPrevention", sampleDataSecondaryPrevention, setSecondaryPrevention) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="secondaryPreventionEditor"
                          ref={secondaryPreventionRef}
                          value={values?.secondaryPrevention}
                          tabIndex={3}
                          // onChange={(newContent) => { setSecondaryPrevention(newContent) }}
                          onChange={(newContent) => setFieldValue("secondaryPrevention", newContent)}
                          onBlur={handleBlur}
                          className='secondaryPrevention'
                        />
                        {/* {errors.secondaryPreventionEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.secondaryPreventionEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>


                    {/* Things to do when I display amber behaviours:  */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark cleanBg">
                          <h3>Things to do when I display amber behaviours</h3>
                          {/* <span onClick={() => { loadSamplePbsData("thingsToDisplayAmberBehavior", sampleDataThingsToDisplayAmberBehavior, setThingsToDisplayAmberBehavior) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="postThingsToDisplayAmberBehaviorEditor"
                          ref={postThingsToDisplayAmberBehaviorRef}
                          value={values?.thingsToDisplayAmberBehavior}
                          tabIndex={5}
                          // onChange={(newContent) => { setThingsToDisplayAmberBehavior(newContent) }}
                          onChange={(newContent) => setFieldValue("thingsToDisplayAmberBehavior", newContent)}
                          onBlur={handleBlur}
                          className='clean'
                        />
                        {/* {errors.postThingsToDisplayAmberBehaviorEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.postThingsToDisplayAmberBehaviorEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>


                    {/* Reactive Strategies */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark rsBg">
                          <h3>Reactive Strategies<br />
                            Behaviours displayed in crisis include</h3>
                          {/* <span onClick={() => { loadSamplePbsData("reactiveStartegies", sampleDataReactiveStartegies, setReactiveStartegies) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="reactiveStartegiesEditor"
                          ref={reactiveStartegiesRef}
                          value={values?.reactiveStartegies}
                          tabIndex={4}
                          // onChange={(newContent) => { setReactiveStartegies(newContent) }}
                          onChange={(newContent) => setFieldValue("reactiveStartegies", newContent)}
                          onBlur={handleBlur}
                          className='reactiveStartegies'
                        />
                        {/* {errors.reactiveStartegiesEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.reactiveStartegiesEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>

                    {/* Things to try when I am in crisis:  */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark cleanBg">
                          <h3>Things to try when I am in crisis</h3>
                          {/* <span onClick={() => { loadSamplePbsData("postThingsToTry", sampleDataPostThingsToTry, setPostThingsToTry) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="postThingsToTry"
                          ref={postThingsToTryRef}
                          value={values?.postThingsToTry}
                          tabIndex={5}
                          // onChange={(newContent) => { setPostThingsToTry(newContent) }}
                          onChange={(newContent) => setFieldValue("postThingsToTry", newContent)}
                          onBlur={handleBlur}
                          className='clean'
                        />
                        {/* {errors.postThingsToTryEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.postThingsToTryEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>


                    {/* Post Incident Support- Recovery */}
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <header className="alert alert-dark pisrBg">
                          <h3>Post Incident Support- Recovery</h3>
                          {/* <span onClick={() => { loadSamplePbsData("postIncidentSupport", sampleDataPostIncidentSupport, setPostIncidentSupport) }} className='btn btn-sm btn-success'>Load Sample Data</span> */}
                        </header>
                        <JoditEditor
                          name="postIncidentSupportEditor"
                          ref={postIncidentSupportRef}
                          value={values?.postIncidentSupport}
                          tabIndex={5}
                          // onChange={(newContent) => { setPostIncidentSupport(newContent) }}
                          onChange={(newContent) => setFieldValue("postIncidentSupport", newContent)}
                          onBlur={handleBlur}
                          className='pisr'
                        />
                        {/* {errors.postIncidentSupportEditor && (
                          <div className="validationError">
                            <div className="text-danger">{errors.postIncidentSupportEditor}</div>
                          </div>
                        )} */}
                      </div>
                    </div>

                  </div>
                </div>
                <div className="formActionButtons mt-5">
                  <Link to="/pbs-plans">
                    <span
                      className="btn btn-sm btn-outline-primary"
                    >
                      Cancel
                    </span>
                  </Link>
                  {isSubmitButtonClicked ? (
                    <Button
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Save
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
      {isToastAddPbsPlans && <ToastContainer />}
    </>
  );
}

export default AddPbsPlans;